module.exports = __webpack_public_path__ + "static/media/aceton_4.f73271d7.png";